import React, { useState, useEffect, Fragment } from "react";
import { Card, Button, Table, Col } from "react-bootstrap";

const CardTransactions = ({ card }) => {
  const localUser = card;
  const [activeTab, setActiveTab] = useState("transactions");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageDeposit, setCurrentPageDeposit] = useState(1);
  const itemsPerPage = 10; // Set the items per page constant

  // Calculate indices
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const indexOfLastItemDeposit = currentPageDeposit * itemsPerPage;
  const indexOfFirstItemDeposit = indexOfLastItemDeposit - itemsPerPage;

  // Ensure that transactions_inbanx and topup_inbanx are treated as arrays
  const transactions = Array.isArray(localUser?.transactions_inbanx)
    ? [...localUser.transactions_inbanx] // Clone the array to prevent mutation of the original data
    : Object.values(localUser?.transactions_inbanx || []);

  const topupTransactions = Array.isArray(localUser?.topup_inbanx)
    ? [...localUser.topup_inbanx] // Clone the array to prevent mutation of the original data
    : Object.values(localUser?.topup_inbanx || []);

  // Assuming dateCreated is a Date-like property, we parse each as a new Date object

  // sort transactions
  transactions.sort(
    (a, b) =>
      new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
  );

  // sort topupTransactions
  topupTransactions.sort(
    (a, b) =>
      new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
  );

  // Slice the transactions array
  const currentItems = transactions
    .filter(
      (transaction) =>
        transaction !== null && transaction.description !== "Card Top Up"
    )
    .slice(indexOfFirstItem, indexOfLastItem);

  const currentItemsDeposits = topupTransactions
    .filter((transaction) => transaction !== null)
    .slice(indexOfFirstItemDeposit, indexOfLastItemDeposit);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const nextPageDeposit = () => {
    setCurrentPageDeposit((prev) => prev + 1);
  };

  const prevPageDeposit = () => {
    if (currentPageDeposit > 1) {
      setCurrentPageDeposit((prev) => prev - 1);
    }
  };

  const nextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <Fragment>
      <div>
        <Col>
          <Card>
            <div className="card-header border-0 pb-0">
              <ul className="nav nav-tabs card-header-tabs">
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "transactions" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("transactions")}
                  >
                    Spendings
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "deposits" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("deposits")}
                  >
                    Deposits
                  </a>
                </li>
              </ul>
            </div>
            <div className="tab-content">
              <Card.Body>
                {activeTab === "transactions" && (
                  <>
                    <div className="tab-pane fade show active">
                      <Table responsive>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((transaction) => (
                              <tr className="text-black" key={transaction.id}>
                                <td className="text-black">
                                  {transaction.description}
                                </td>
                                <td
                                  className="text-black"
                                  style={{ width: "110px" }}
                                >
                                  -{Number(transaction.amount / 100).toFixed(2)}{" "}
                                  USD
                                </td>
                                <td className="text-black">
                                  {transaction.dateCreated.split(" ")[0]}
                                </td>
                                <td className="text-success">Completed</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                className="text-black text-center"
                                colSpan="4"
                              >
                                No Transactions available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          className="btn btn-primary m-2"
                          onClick={prevPage}
                          disabled={currentPage === 1}
                        >
                          <i className="fa-solid fa-chevron-left"></i>
                        </button>
                        <button
                          className="btn btn-primary m-2"
                          onClick={nextPage}
                          disabled={
                            currentPage ===
                            Math.ceil(transactions.length / itemsPerPage)
                          }
                        >
                          <i className="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {activeTab === "deposits" && (
                  <>
                    <Table responsive>
                      <tbody>
                        {currentItemsDeposits.map((transaction) => (
                          <tr className="text-black" key={transaction.id}>
                            <td className="text-black">
                              {transaction.description}
                            </td>
                            <td
                              className="text-black"
                              style={{ width: "130px" }}
                            >
                              +{Number(transaction.amount / 100).toFixed(2)}{" "}
                              USDT
                            </td>
                            <td className="text-black">
                              {transaction.dateCreated.split(" ")[0]}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        className="btn btn-primary m-2"
                        onClick={prevPageDeposit}
                        disabled={currentPageDeposit === 1}
                      >
                        <i className="fa-solid fa-chevron-left"></i>
                      </button>
                      <button
                        className="btn btn-primary m-2"
                        onClick={nextPageDeposit}
                        disabled={
                          currentPageDeposit ===
                          Math.ceil(topupTransactions.length / itemsPerPage)
                        }
                      >
                        <i className="fa-solid fa-chevron-right"></i>
                      </button>
                    </div>
                  </>
                )}
              </Card.Body>
            </div>
          </Card>
        </Col>
      </div>
    </Fragment>
  );
};

export default CardTransactions;
